(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[576],{

/***/ 5576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IN": function() { return /* reexport */ advantage; },
  "I7": function() { return /* reexport */ announcement; },
  "$_": function() { return /* reexport */ footer; },
  "FS": function() { return /* reexport */ homeBanner; },
  "NE": function() { return /* reexport */ homeData; },
  "Gg": function() { return /* reexport */ hoverComp; },
  "kT": function() { return /* reexport */ partner; },
  "hO": function() { return /* reexport */ perpetualFutures; },
  "wG": function() { return /* reexport */ roadmap; },
  "cU": function() { return /* reexport */ security; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(7458);
// EXTERNAL MODULE: ../../libs/base-hooks/src/index.ts + 4 modules
var src = __webpack_require__(7747);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.0_@babel+core@7.22.8_react-dom@18.2.0_react@18.2.0/node_modules/next/config.js
var config = __webpack_require__(1733);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.0_@babel+core@7.22.8_react-dom@18.2.0_react@18.2.0/node_modules/next/router.js
var next_router = __webpack_require__(9004);
;// CONCATENATED MODULE: ./utils/index.ts
// @ts-nocheck
function formatThousandDigit(val) {
    if (val === null || val === void 0 ? void 0 : val.includes(".")) {
        const splitValue = val.split(".");
        const formatInt = Number(splitValue[0]).toLocaleString();
        const decimals = splitValue[1];
        return formatInt + "." + decimals;
    } else {
        return Number(val).toLocaleString();
    }
}
function emailCheck(val) {
    return /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(val);
}
function getLang() {
    if (true) {
        const langReg = /([a-z]{2}-[A-Z]{2})/;
        let refLang = location.href.match(langReg);
        if (refLang) {
            refLang = refLang[0];
        }
        const lang = refLang || localStorage.getItem("LANG_KEY") || "en-US";
        //获取到之后set
        localStorage.setItem("LANG_KEY", lang);
        return lang;
    }
    return "en-US";
}
const getUrlAfterLangChange = (path)=>{
    if (true) {
        const langReg = /([a-z]{2}-[A-Z]{2,3})/;
        let lang = getLang();
        // 导航上有语言，直接拼接
        //如果是en-US/aboutUs点击呢
        // if (langReg.test(location.href)) {
        //   lang = location.href.match(langReg)[0];
        // }
        const newUrl = "/".concat(lang).concat(path, "/");
        return newUrl;
    }
    console.log("newUrl no broswer", path);
    return path;
};

// EXTERNAL MODULE: ./components/HomePage/footer/index.module.less
var index_module = __webpack_require__(5369);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/HomePage/footer/index.tsx






const { staticFolder  } = config_default()().publicRuntimeConfig;
const Footer = (props)=>{
    const t = (0,src/* useFm */.yv)();
    const router = (0,next_router.useRouter)();
    const gotoAboutPage = ()=>{
        // router.push(getUrlAfterLangChange('/aboutUs')); //...locales报错
        const url = getUrlAfterLangChange("/aboutUs");
        location.href = url;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "footer-wrapper",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container-default w-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer-top",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-layout-grid grid-footer-v1---4-column ".concat((index_module_default()).gridWrapper),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                // id="w-node-e3565173-e9d2-3001-847c-69d20877c713-0877c70f"
                                "data-w-id": "e3565173-e9d2-3001-847c-69d20877c713",
                                className: "footer-cta-wrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "footer-cta-content-top ".concat((index_module_default()).content),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "footer-cta-content-top---wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "inner-container _388px",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "color-neutral-800 mg-bottom-24px",
                                                        children: t("footerTitle")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "/trade/usdt/BTCUSDT",
                                                        className: "btn-primary color-neutral-800 w-button ".concat((index_module_default()).btn),
                                                        children: t("tradeNow")
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "image-wrapper footer-cta-image",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "".concat(staticFolder, "/mufex/images/footer/h5-bg.png"),
                                            loading: "eager",
                                            className: "image"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                // id="w-node-e3565173-e9d2-3001-847c-69d20877c71d-0877c70f"
                                "data-w-id": "e3565173-e9d2-3001-847c-69d20877c71d",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "footer-title",
                                        children: t("aboutUS")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        role: "list",
                                        className: "footer-list-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "footer-list-item",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    onClick: gotoAboutPage,
                                                    className: "footer-link",
                                                    children: t("aboutUS")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "footer-list-item",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: " https://blog.mufex.finance",
                                                    className: "footer-link",
                                                    children: t("announcement")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "footer-list-item last",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://docs.mufex.finance/mufex/support/mufex-affiliate-program",
                                                    className: "footer-link",
                                                    children: t("affiliateProgram")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                "data-w-id": "e3565173-e9d2-3001-847c-69d20877c74e",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "footer-title",
                                        children: t("helpCenter")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        role: "list",
                                        className: "footer-list-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "footer-list-item",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: " https://docs.mufex.finance/mufex/start-using-mufex/trading/contract-specs",
                                                    className: "footer-link",
                                                    children: t("perpetualDerivatives")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "footer-list-item",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: " https://docs.mufex.finance/mufex/start-using-mufex/fee-rates",
                                                    className: "footer-link",
                                                    children: t("feeRate")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "footer-list-item",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://docs.mufex.finance/mufex/start-using-mufex/trading/trading-rules",
                                                    className: "footer-link",
                                                    children: t("tradingRules")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "footer-list-item",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://www.mufex.finance/apidocs/derivatives/contract/index.html#t-authentication",
                                                    className: "footer-link",
                                                    children: "API"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "footer-list-item",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://docs.mufex.finance/mufex/support/faq",
                                                    className: "footer-link",
                                                    children: t("FAQ")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "footer-list-item last",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "mailto:support@mufex.finance",
                                                    className: "footer-link",
                                                    children: t("feedback")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                "data-w-id": "e3565173-e9d2-3001-847c-69d20877c75e",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "footer-title",
                                        children: t("followUs")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        role: "list",
                                        className: "footer-list-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "footer-list-item",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: "https://twitter.com/mufex_Official/",
                                                    className: "footer-link ".concat((index_module_default()).socialwrapper),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                            width: "24",
                                                            height: "24",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                                    className: (index_module_default()).socialBase,
                                                                    width: "24",
                                                                    height: "24",
                                                                    rx: "8",
                                                                    fill: "white"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M14.3544 6.32332V6.3208H15.0108L15.2507 6.36871C15.4106 6.39981 15.5558 6.44056 15.6862 6.49099C15.8167 6.54141 15.9429 6.60025 16.0649 6.66748C16.187 6.73471 16.2976 6.80321 16.3969 6.87297C16.4954 6.94189 16.5838 7.015 16.6621 7.09232C16.7395 7.17048 16.8602 7.19065 17.0243 7.15283C17.1885 7.11501 17.3652 7.06248 17.5546 6.99525C17.7439 6.92802 17.9312 6.85238 18.1163 6.76833C18.3015 6.68428 18.4143 6.63092 18.4547 6.60823C18.4942 6.58471 18.5153 6.5721 18.5178 6.57041L18.5203 6.56663L18.5329 6.56032L18.5455 6.55402L18.5582 6.54772L18.5708 6.54141L18.5733 6.53763L18.5771 6.53511L18.5809 6.53259L18.5834 6.52881L18.596 6.52503L18.6087 6.52251L18.6061 6.54141L18.6023 6.56032L18.596 6.57923L18.5897 6.59814L18.5834 6.61075L18.5771 6.62336L18.5708 6.64227C18.5666 6.65487 18.5624 6.67168 18.5582 6.69269C18.554 6.71371 18.514 6.79774 18.4382 6.94482C18.3625 7.0919 18.2678 7.24108 18.1542 7.39236C18.0406 7.54363 17.9388 7.65792 17.8487 7.73525C17.7578 7.81341 17.6976 7.86804 17.6682 7.89914C17.6387 7.93107 17.603 7.96048 17.5609 7.98738L17.4977 8.02899L17.4851 8.03529L17.4725 8.04159L17.47 8.04537L17.4662 8.04789L17.4624 8.05042L17.4599 8.0542L17.4472 8.0605L17.4346 8.0668L17.4321 8.07059L17.4283 8.07311L17.4245 8.07563L17.422 8.07941L17.4195 8.08319L17.4157 8.08571L17.4119 8.08824L17.4094 8.09202H17.4725L17.826 8.01638C18.0616 7.96595 18.2867 7.90503 18.5014 7.83358L18.8422 7.72013L18.8801 7.70752L18.899 7.70122L18.9116 7.69491L18.9243 7.68861L18.9369 7.68231L18.9495 7.676L18.9748 7.67222L19 7.6697V7.69491L18.9937 7.69743L18.9874 7.70122L18.9849 7.705L18.9811 7.70752L18.9773 7.71004L18.9748 7.71382L18.9722 7.7176L18.9684 7.72013L18.9647 7.72265L18.9621 7.72643L18.9596 7.73021L18.9558 7.73273L18.9495 7.74534L18.9432 7.75794L18.9394 7.76047C18.9377 7.76299 18.8843 7.83442 18.7791 7.97478C18.6739 8.11597 18.6171 8.1874 18.6087 8.18909C18.6002 8.19161 18.5885 8.20422 18.5733 8.22691C18.559 8.25043 18.4698 8.34415 18.3057 8.50803C18.1416 8.67192 17.9808 8.81772 17.8235 8.94548C17.6652 9.07407 17.5853 9.23206 17.5836 9.41948C17.5811 9.60606 17.5714 9.81702 17.5546 10.0523C17.5377 10.2877 17.5062 10.5419 17.4599 10.815C17.4136 11.0882 17.3421 11.397 17.2453 11.7416C17.1485 12.0862 17.0307 12.4224 16.8918 12.7501C16.7529 13.0779 16.6078 13.372 16.4563 13.6326C16.3048 13.8931 16.1659 14.1137 16.0397 14.2944C15.9134 14.4751 15.7851 14.6453 15.6546 14.805C15.5242 14.9647 15.3593 15.1445 15.1598 15.3446C14.9595 15.5437 14.8501 15.653 14.8316 15.6723C14.8122 15.6908 14.7297 15.7597 14.5841 15.8791C14.4394 15.9992 14.2837 16.1194 14.117 16.2396C13.9513 16.359 13.7989 16.4586 13.6601 16.5384C13.5212 16.6182 13.3537 16.7094 13.1576 16.812C12.9624 16.9153 12.7511 17.0111 12.5239 17.0994C12.2967 17.1876 12.0568 17.2696 11.8043 17.3452C11.5518 17.4208 11.3078 17.4797 11.0721 17.5217C10.8365 17.5637 10.5693 17.5994 10.2705 17.6289L9.82236 17.673V17.6793H9.0018V17.673L8.8945 17.6667C8.82297 17.6625 8.76406 17.6583 8.71776 17.6541C8.67148 17.6499 8.49684 17.6267 8.19387 17.5847C7.89089 17.5427 7.65315 17.5007 7.48061 17.4587C7.30809 17.4166 7.0514 17.3368 6.71055 17.2191C6.3697 17.1015 6.07809 16.9826 5.83571 16.8624C5.59417 16.743 5.44269 16.6674 5.38124 16.6355C5.32065 16.6044 5.25248 16.5657 5.17674 16.5195L5.06312 16.4501L5.06061 16.4464L5.05681 16.4438L5.05302 16.4413L5.0505 16.4375L5.03787 16.4312L5.02525 16.4249L5.02274 16.4211L5.01894 16.4186L5.01515 16.4161L5.01262 16.4123L5.01011 16.4085L5.00631 16.406H5V16.3808L5.01262 16.3833L5.02525 16.3871L5.08206 16.3934C5.11993 16.3976 5.22303 16.4039 5.39134 16.4123C5.55967 16.4207 5.7385 16.4207 5.92786 16.4123C6.11722 16.4039 6.3108 16.385 6.50857 16.3556C6.70635 16.3262 6.93989 16.2758 7.2092 16.2043C7.47852 16.1329 7.72595 16.048 7.9515 15.9497C8.17621 15.8505 8.3361 15.7765 8.43121 15.7278C8.52546 15.6799 8.66938 15.5908 8.86294 15.4605L9.15329 15.2651L9.15582 15.2613L9.1596 15.2588L9.1634 15.2563L9.16592 15.2525L9.16844 15.2487L9.17223 15.2462L9.17603 15.2437L9.17854 15.2399L9.19116 15.2361L9.20379 15.2336L9.20631 15.221L9.2101 15.2084L9.2139 15.2059L9.21641 15.2021L9.11542 15.1958C9.0481 15.1916 8.98287 15.1874 8.91975 15.1832C8.85663 15.179 8.75774 15.1601 8.62308 15.1265C8.48844 15.0928 8.34326 15.0424 8.18756 14.9752C8.03186 14.908 7.88038 14.8281 7.73309 14.7357C7.58582 14.6432 7.47935 14.5663 7.41371 14.505C7.34891 14.4444 7.26474 14.3587 7.16123 14.2478C7.05856 14.136 6.96934 14.0213 6.8936 13.9036C6.81785 13.786 6.74548 13.6502 6.67648 13.4964L6.57169 13.267L6.56537 13.2481L6.55906 13.2292L6.55527 13.2166L6.55275 13.204L6.57169 13.2065L6.59062 13.2103L6.72949 13.2292C6.82207 13.2418 6.96725 13.246 7.16501 13.2418C7.36279 13.2376 7.49955 13.2292 7.57529 13.2166C7.65104 13.204 7.69733 13.1956 7.71416 13.1914L7.7394 13.1851L7.77096 13.1788L7.80252 13.1724L7.80505 13.1687L7.80884 13.1661L7.81264 13.1636L7.81515 13.1598L7.7899 13.1535L7.76465 13.1472L7.7394 13.1409L7.71416 13.1346L7.68891 13.1283C7.67208 13.1241 7.64263 13.1157 7.60054 13.1031C7.55847 13.0905 7.44485 13.0443 7.25969 12.9644C7.07455 12.8846 6.92727 12.8069 6.81785 12.7312C6.70817 12.6554 6.60359 12.5724 6.50478 12.4829C6.40631 12.3921 6.29817 12.2753 6.18034 12.1324C6.06252 11.9895 5.95733 11.8235 5.86474 11.6345C5.77217 11.4454 5.70274 11.2647 5.65645 11.0924C5.61034 10.9211 5.57992 10.746 5.56557 10.5692L5.54283 10.3045L5.55546 10.307L5.56808 10.3108L5.5807 10.3171L5.59333 10.3234L5.60595 10.3297L5.61858 10.336L5.81425 10.4242C5.9447 10.4831 6.10671 10.5335 6.30027 10.5755C6.49385 10.6175 6.60956 10.6406 6.64743 10.6448L6.70424 10.6511H6.81785L6.81534 10.6474L6.81154 10.6448L6.80775 10.6423L6.80523 10.6385L6.80272 10.6348L6.79892 10.6322L6.79513 10.6297L6.79261 10.6259L6.77998 10.6196L6.76736 10.6133L6.76485 10.6095L6.76105 10.607L6.75726 10.6045L6.75473 10.6007L6.74211 10.5944L6.72949 10.5881L6.72697 10.5843C6.72445 10.5826 6.68826 10.5557 6.61839 10.5036C6.54938 10.4507 6.47701 10.3822 6.40126 10.2982C6.32552 10.2141 6.24977 10.1259 6.17403 10.0334C6.09815 9.94077 6.03056 9.84164 5.97205 9.73717C5.91314 9.63212 5.85086 9.49848 5.78521 9.33628C5.72041 9.17492 5.67118 9.01229 5.63751 8.84841C5.60386 8.68452 5.58492 8.52274 5.5807 8.36306C5.5765 8.20337 5.5807 8.0668 5.59333 7.95335C5.60595 7.83989 5.6312 7.71172 5.66907 7.56885C5.70694 7.42598 5.76166 7.2747 5.83318 7.11501L5.94049 6.87549L5.9468 6.85658L5.95311 6.83767L5.95691 6.83515L5.95942 6.83137L5.96195 6.82758L5.96573 6.82506L5.96953 6.82758L5.97205 6.83137L5.97457 6.83515L5.97836 6.83767L5.98216 6.84019L5.98467 6.84397L5.9872 6.84775L5.99098 6.85027L5.99729 6.86288L6.00361 6.87549L6.00741 6.87801L6.00992 6.88179L6.18034 7.07089C6.29396 7.19695 6.42862 7.33773 6.58431 7.49321C6.74001 7.64868 6.82627 7.72937 6.8431 7.73525C6.85994 7.74197 6.88097 7.7613 6.90622 7.79324C6.93147 7.82434 7.01563 7.89872 7.1587 8.01638C7.30178 8.13404 7.48903 8.27061 7.72047 8.42609C7.95192 8.58157 8.2086 8.73495 8.49053 8.88623C8.77248 9.03751 9.07545 9.17407 9.39946 9.29594C9.72348 9.41781 9.95071 9.49765 10.0812 9.53546C10.2116 9.57328 10.4346 9.62161 10.7502 9.68044C11.0658 9.73927 11.3036 9.77709 11.4635 9.7939C11.6234 9.8107 11.7328 9.82037 11.7917 9.82289L11.8801 9.82541L11.8776 9.80651L11.8738 9.7876L11.8485 9.63001C11.8317 9.52496 11.8233 9.37788 11.8233 9.18879C11.8233 8.99969 11.838 8.8253 11.8674 8.66561C11.8969 8.50593 11.9411 8.34415 12 8.18026C12.0589 8.01638 12.1166 7.88484 12.1729 7.78568C12.2302 7.68735 12.3051 7.57515 12.3977 7.44908C12.4902 7.32302 12.6102 7.19276 12.7574 7.05828C12.9047 6.92381 13.073 6.80405 13.2624 6.699C13.4518 6.59395 13.6264 6.5141 13.7863 6.45947C13.9462 6.40485 14.0809 6.36912 14.1903 6.35232C14.2997 6.33551 14.3544 6.32584 14.3544 6.32332Z",
                                                                    fill: "black"
                                                                })
                                                            ]
                                                        }),
                                                        t("twitter")
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "footer-list-item",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: "https://t.me/mufex",
                                                    className: "footer-link ".concat((index_module_default()).socialwrapper),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                            width: "24",
                                                            height: "24",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                                    className: (index_module_default()).socialBase,
                                                                    width: "24",
                                                                    height: "24",
                                                                    rx: "8",
                                                                    fill: "white"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M4.54635 11.2081C4.54635 11.2081 11.1145 8.51253 13.3925 7.56335C14.2657 7.1837 17.2271 5.96875 17.2271 5.96875C17.2271 5.96875 18.5939 5.43725 18.48 6.72808C18.442 7.25963 18.1383 9.11995 17.8346 11.1322C17.379 13.9797 16.8854 17.0929 16.8854 17.0929C16.8854 17.0929 16.8095 17.9661 16.1641 18.118C15.5186 18.2699 14.4555 17.5865 14.2657 17.4346C14.1138 17.3207 11.4182 15.6122 10.4311 14.7769C10.1654 14.5492 9.86164 14.0936 10.4691 13.562C11.8359 12.3091 13.4684 10.7525 14.4555 9.76542C14.9112 9.3098 15.3667 8.24675 13.4684 9.53759C10.7728 11.398 8.11519 13.1444 8.11519 13.1444C8.11519 13.1444 7.50771 13.5241 6.36873 13.1824C5.2297 12.8407 3.90088 12.3851 3.90088 12.3851C3.90088 12.3851 2.98974 11.8156 4.54635 11.2081Z",
                                                                    fill: "black"
                                                                })
                                                            ]
                                                        }),
                                                        t("telegram")
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "footer-list-item",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: "https://discord.com/invite/m6DD42s46n",
                                                    className: "footer-link ".concat((index_module_default()).socialwrapper),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                            width: "24",
                                                            height: "24",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                                    className: (index_module_default()).socialBase,
                                                                    width: "24",
                                                                    height: "24",
                                                                    rx: "8",
                                                                    fill: "white"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M17.463 7.02731C19.2367 9.63525 20.1127 12.5769 19.7853 15.9635C19.7839 15.9778 19.7764 15.991 19.7647 15.9996C18.4214 16.9859 17.12 17.5845 15.8368 17.9815C15.8268 17.9845 15.8162 17.9844 15.8063 17.981C15.7964 17.9777 15.7878 17.9713 15.7817 17.9628C15.4852 17.5504 15.2159 17.1155 14.9799 16.6589C14.9663 16.632 14.9787 16.5996 15.0066 16.589C15.4344 16.4278 15.8412 16.2346 16.2324 16.0059C16.2632 15.9878 16.2652 15.9437 16.2367 15.9225C16.1537 15.8608 16.0714 15.796 15.9927 15.7312C15.978 15.7193 15.9582 15.7169 15.9415 15.725C13.4013 16.898 10.6186 16.898 8.04835 15.725C8.03166 15.7175 8.01183 15.7201 7.9975 15.7318C7.91897 15.7966 7.83652 15.8608 7.75426 15.9225C7.72579 15.9437 7.72815 15.9878 7.75917 16.0059C8.15044 16.2303 8.55721 16.4278 8.98441 16.5898C9.01209 16.6004 9.02525 16.632 9.0115 16.6589C8.78063 17.1161 8.51128 17.551 8.20933 17.9634C8.19618 17.9801 8.17458 17.9878 8.15417 17.9815C6.87709 17.5845 5.57567 16.9859 4.23244 15.9996C4.22125 15.991 4.2132 15.9772 4.21202 15.9629C3.93835 13.0336 4.4961 10.0676 6.53215 7.02672C6.53706 7.01867 6.54452 7.01239 6.55316 7.00866C7.55499 6.54887 8.62828 6.21061 9.75007 6.01743C9.77048 6.01429 9.7909 6.02371 9.8015 6.04177C9.94011 6.28718 10.0985 6.60188 10.2057 6.85906C11.3882 6.67845 12.5891 6.67845 13.7963 6.85906C13.9035 6.60738 14.0564 6.28718 14.1944 6.04177C14.1993 6.03281 14.2069 6.02563 14.2162 6.02126C14.2254 6.01689 14.2358 6.01555 14.2458 6.01743C15.3682 6.2112 16.4415 6.54946 17.4426 7.00866C17.4514 7.01239 17.4587 7.01867 17.463 7.02731ZM10.8069 12.597C10.8192 11.731 10.1879 11.0144 9.39531 11.0144C8.60924 11.0144 7.98395 11.7247 7.98395 12.597C7.98395 13.469 8.62161 14.1793 9.39531 14.1793C10.1816 14.1793 10.8069 13.469 10.8069 12.597ZM16.0255 12.597C16.0379 11.731 15.4065 11.0144 14.6141 11.0144C13.8279 11.0144 13.2026 11.7247 13.2026 12.597C13.2026 13.469 13.8402 14.1793 14.6141 14.1793C15.4065 14.1793 16.0255 13.469 16.0255 12.597Z",
                                                                    fill: "black"
                                                                })
                                                            ]
                                                        }),
                                                        t("discord")
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "footer-list-item",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: "https://www.youtube.com/channel/UC0VQ8_HuC8yeiJvEbrfmRqw",
                                                    className: "footer-link ".concat((index_module_default()).socialwrapper),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                            width: "24",
                                                            height: "24",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                                    className: (index_module_default()).socialBase,
                                                                    width: "24",
                                                                    height: "24",
                                                                    rx: "8",
                                                                    fill: "white"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M12.3102 16.9354L9.4379 16.8817C8.50793 16.863 7.57564 16.9003 6.6639 16.7065C5.27694 16.417 5.17868 14.9972 5.07587 13.8063C4.9342 12.1321 4.98904 10.4275 5.25639 8.76724C5.40732 7.83566 6.00128 7.27978 6.91982 7.21929C10.0206 6.99976 13.1419 7.02578 16.2358 7.1282C16.5626 7.13759 16.8916 7.1889 17.2138 7.24731C18.8042 7.53221 18.843 9.14107 18.9461 10.4954C19.0489 11.8638 19.0055 13.2391 18.809 14.5982C18.6513 15.7234 18.3497 16.667 17.0767 16.7581C15.4817 16.8772 13.9233 16.9731 12.3238 16.9426C12.3239 16.9354 12.3147 16.9354 12.3102 16.9354ZM10.6216 14.0866C11.8235 13.3813 13.0025 12.6879 14.1976 11.9873C12.9934 11.2821 11.8166 10.5886 10.6216 9.8881V14.0866Z",
                                                                    fill: "black"
                                                                })
                                                            ]
                                                        }),
                                                        t("youtube")
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "footer-list-item",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: "https://blog.mufex.finance/",
                                                    className: "footer-link ".concat((index_module_default()).socialwrapper),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                            width: "24",
                                                            height: "24",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                                    className: (index_module_default()).socialBase,
                                                                    width: "24",
                                                                    height: "24",
                                                                    rx: "8",
                                                                    fill: "white"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                                    clipPath: "url(#clip0_2307_26905)",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M12.8968 11.9998C12.8968 14.1954 11.1291 15.9754 8.94834 15.9754C6.76763 15.9754 5 14.196 5 11.9998C5 9.8037 6.76777 8.02441 8.94834 8.02441C11.1289 8.02441 12.8968 9.80424 12.8968 11.9998ZM17.2283 11.9998C17.2283 14.0667 16.3444 15.7421 15.2541 15.7421C14.1638 15.7421 13.2799 14.0662 13.2799 11.9998C13.2799 9.93349 14.1638 8.25757 15.2541 8.25757C16.3444 8.25757 17.2283 9.93349 17.2283 11.9998ZM19 11.9998C19 13.8517 18.6891 15.3527 18.3056 15.3527C17.9222 15.3527 17.6113 13.8511 17.6113 11.9998C17.6113 10.1485 17.9222 8.64692 18.3058 8.64692C18.6894 8.64692 19 10.1481 19 11.9998Z",
                                                                        fill: "black"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                                        id: "clip0_2307_26905",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                                            className: (index_module_default()).socialBase,
                                                                            width: "14",
                                                                            height: "14",
                                                                            fill: "white",
                                                                            transform: "translate(5 5)"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        t("medium")
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-w-id": "e3565173-e9d2-3001-847c-69d20877c774",
                className: "divider _0px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container-default w-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer-bottom",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        "data-w-id": "e3565173-e9d2-3001-847c-69d20877c777",
                        className: "grid-footer-bottom-v1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/",
                                className: "footer-logo-link w-inline-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(staticFolder, "/mufex/images/header/logo.svg"),
                                    loading: "eager",
                                    alt: "MUFEX-LOGO"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mg-bottom-0 copy-right-color",
                                children: "Copyright\xa9 DLT Limited. All rights reserved."
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var footer = (Footer);

// EXTERNAL MODULE: ./components/HomePage/partner/index.module.less
var partner_index_module = __webpack_require__(9182);
var partner_index_module_default = /*#__PURE__*/__webpack_require__.n(partner_index_module);
;// CONCATENATED MODULE: ./components/HomePage/partner/index.tsx




const { staticFolder: partner_staticFolder  } = config_default()().publicRuntimeConfig;
const Partner = (props)=>{
    const t = (0,src/* useFm */.yv)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "section pd-128px wf-section bg-secondary-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-w-id": "cd49c5f0-c3b7-c48d-73ff-0422dd1ccdd1",
                className: "container-default w-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center mg-bottom-72px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "display-2",
                        dangerouslySetInnerHTML: {
                            __html: t("h-2-t")
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((partner_index_module_default()).partnerClass, " "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (partner_index_module_default()).imgWrapperClass,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/aribitrum.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-arbitrum"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/polygon.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-polygon"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/chainlink.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-hainlink"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/unipass.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-unipass"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/scroll.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-scroll"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/afflux.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-afflux"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/beosin.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-beosin"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/c-cubed.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-c-cubed"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/metatrust.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-metatrust"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/particle.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-particle-network"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/numen.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-numen"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/rugrap.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-rugrap"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/secure3.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-secure3"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/hxr.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-HXR trade"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/aribitrum.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-arbitrum"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/polygon.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-polygon"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/chainlink.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-hainlink"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/unipass.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-unipass"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/scroll.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-scroll"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/afflux.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-afflux"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(partner_staticFolder, "/mufex/images/partnersLogo/beosin.svg"),
                            loading: "eager",
                            alt: "MUFEX-partners-beosin"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var partner = (Partner);

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(2983);
// EXTERNAL MODULE: ./components/downloadIcons/index.tsx
var downloadIcons = __webpack_require__(7960);
// EXTERNAL MODULE: ./components/HomePage/homeBanner/index.module.less
var homeBanner_index_module = __webpack_require__(371);
var homeBanner_index_module_default = /*#__PURE__*/__webpack_require__.n(homeBanner_index_module);
;// CONCATENATED MODULE: ./components/HomePage/homeBanner/index.tsx
// @ts-ignore






const { staticFolder: homeBanner_staticFolder  } = config_default()().publicRuntimeConfig;
const HomeBanner = (props)=>{
    const t = (0,src/* useFm */.yv)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "section hero-v1 wf-section ".concat((homeBanner_index_module_default()).homeBanner),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container-default w-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "inner-container _650px---tablet center _100---mbl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center---tablet",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-layout-grid grid-2-columns home-hero-grid",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                "data-w-id": "cd49c5f0-c3b7-c48d-73ff-0422dd1ccdba",
                                className: "inner-container _515px _100---tablet",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "inner-container _550px---mbl center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "display-1",
                                            dangerouslySetInnerHTML: {
                                                __html: t("h-1-t")
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "inner-container _550px---tablet center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "inner-container _500px---mbl center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "inner-container _500px full-width-tablet",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "mg-bottom-40px",
                                                            dangerouslySetInnerHTML: {
                                                                __html: t("h-1-desc")
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "buttons-row center---tablet",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            href: "/trade/usdt/BTCUSDT",
                                                            className: "btn-primary button-row w-button ".concat((homeBanner_index_module_default()).btn),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: t("h-1-btn")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                                    width: "20",
                                                                    height: "21",
                                                                    viewBox: "0 0 20 21",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M10.4492 3.44922L17.4999 10.4999L10.4492 17.5507",
                                                                            stroke: "black",
                                                                            strokeWidth: "1.66667",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M17.4999 10.5L2.5 10.5",
                                                                            stroke: "black",
                                                                            strokeWidth: "1.66667",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "buttons-row center---tablet",
                                                        style: {
                                                            marginTop: "48px"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(downloadIcons/* default */.Z, {})
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                "data-w-id": "cd49c5f0-c3b7-c48d-73ff-0422dd1ccdc6",
                                className: "hero-image-container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        "data-w-id": "cd49c5f0-c3b7-c48d-73ff-0422dd1ccdc7",
                                        className: "image-wrapper hero-float-bottom-right",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "".concat(homeBanner_staticFolder, "/mufex/images/banner/1.png"),
                                            loading: "eager",
                                            alt: "MUFEX-bitcoin"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(homeBanner_staticFolder, "/mufex/images/banner/5.png"),
                                        loading: "eager",
                                        "data-w-id": "cd49c5f0-c3b7-c48d-73ff-0422dd1ccdc9",
                                        alt: "MUFEX-eth",
                                        className: "position-relative main"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        "data-w-id": "cd49c5f0-c3b7-c48d-73ff-0422dd1ccdca",
                                        className: "image-wrapper hero-float-bottom-left float",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "".concat(homeBanner_staticFolder, "/mufex/images/banner/2.png"),
                                            loading: "eager",
                                            alt: "MUFEX-btc"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        "data-w-id": "cd49c5f0-c3b7-c48d-73ff-0422dd1ccdcc",
                                        className: "image-wrapper hero-float-top-left main",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "".concat(homeBanner_staticFolder, "/mufex/images/banner/3.png"),
                                            loading: "eager",
                                            alt: "MUFEX-coin"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        "data-w-id": "cd49c5f0-c3b7-c48d-73ff-0422dd1ccdce",
                                        className: "image-wrapper hero-float-top-right float",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "".concat(homeBanner_staticFolder, "/mufex/images/banner/4.png"),
                                            loading: "eager",
                                            alt: "MUFEX-symbol"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var homeBanner = (HomeBanner);

// EXTERNAL MODULE: ./components/HomePage/advantage/index.module.less
var advantage_index_module = __webpack_require__(1172);
var advantage_index_module_default = /*#__PURE__*/__webpack_require__.n(advantage_index_module);
;// CONCATENATED MODULE: ./components/HomePage/advantage/index.tsx





const { staticFolder: advantage_staticFolder  } = config_default()().publicRuntimeConfig;
const Advantage = (props)=>{
    const t = (0,src/* useFm */.yv)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "section wf-section bg-secondary-3",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container-default w-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mg-bottom-48px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "inner-container _650px---tablet center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inner-container _500px---mbl center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-center---tablet",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-w-id": "d8eeb1fe-fe65-4bc9-67d8-d1be98f314b6",
                                    className: "w-layout-grid grid-2-columns title-and-buttons",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "full-width-tablet",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "display-2 mg-bottom-0",
                                            dangerouslySetInnerHTML: {
                                                __html: t("h-4-t")
                                            }
                                        })
                                    })
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    "data-w-id": "22851834-a059-253a-02cd-e9c0627db8fc",
                    className: "w-layout-grid card features-card-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: "w-node-cd49c5f0-c3b7-c48d-73ff-0422dd1cce3f-1c2c5e56",
                            className: "feature-card large",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "feature-card-large-content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "display-4 mg-bottom-12px",
                                            children: t("h-4-sub1-t")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mg-bottom-24px ".concat((advantage_index_module_default()).lineHeight28),
                                            children: t("h-4-sub1-desc")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "image-wrapper feature-image",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(advantage_staticFolder, "/mufex/images/user/iphone.png"),
                                        loading: "eager",
                                        // sizes="(max-width: 479px) 100vw, (max-width: 767px) 56vw, (max-width: 991px) 28vw, (max-width: 1439px) 22vw, 281.375px"
                                        // srcSet={`${staticFolder}/mufex/images/user/image-mockup-03-finantech-x-webflow-template-p-500.png 500w, /v2/mufex/images/user/image-mockup-03-finantech-x-webflow-template-p-800.png 800w, /v2/mufex/images/user/image-mockup-03-finantech-x-webflow-template-p-1080.png 1080w, /v2/mufex/images/user/image-mockup-03-finantech-x-webflow-template.png 1114w`}
                                        alt: "MUFEX-iphone",
                                        className: "image"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "feature-card top-right",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inner-container _400px---mbl",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(advantage_staticFolder, "/mufex/images/user/1.svg"),
                                        loading: "eager",
                                        alt: "Always Self-Custodial",
                                        className: "mg-bottom-24px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "display-4 mg-bottom-12px",
                                        children: t("h-4-sub2-t")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mg-bottom-12px ".concat((advantage_index_module_default()).lineHeight28),
                                        dangerouslySetInnerHTML: {
                                            __html: t("h-4-sub2-desc")
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mg-bottom-0 ".concat((advantage_index_module_default()).btnLink),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: "/earn",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: t("h-4-sub2-btn")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                    width: "17",
                                                    height: "17",
                                                    viewBox: "0 0 17 17",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M8.85944 2.85938L14.5 8.49995L8.85944 14.1405",
                                                            stroke: "#26F2D1",
                                                            strokeWidth: "1.33333",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M14.4999 8.5L2.5 8.5",
                                                            stroke: "#26F2D1",
                                                            strokeWidth: "1.33333",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "feature-card bottom-left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inner-container _400px---mbl",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(advantage_staticFolder, "/mufex/images/user/2.svg"),
                                        loading: "eager",
                                        alt: "MUFEX-security",
                                        className: "mg-bottom-24px "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "display-4 mg-bottom-12px",
                                        children: t("h-4-sub3-t")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mg-bottom-12px ".concat((advantage_index_module_default()).lineHeight28),
                                        children: t("h-4-sub3-desc")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "feature-card middle",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inner-container _400px---mbl",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(advantage_staticFolder, "/mufex/images/user/3.svg"),
                                        loading: "eager",
                                        alt: "Lightning Fast Experience",
                                        className: "mg-bottom-24px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "display-4 mg-bottom-12px",
                                        dangerouslySetInnerHTML: {
                                            __html: t("h-4-sub4-t")
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mg-bottom-0 ".concat((advantage_index_module_default()).lineHeight28),
                                        children: t("h-4-sub4-desc")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "feature-card",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inner-container _400px---mbl",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(advantage_staticFolder, "/mufex/images/user/4.svg"),
                                        loading: "eager",
                                        alt: "Low Fee",
                                        className: "mg-bottom-24px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "display-4 mg-bottom-12px",
                                        children: t("h-4-sub5-t")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mg-bottom-0 ".concat((advantage_index_module_default()).lineHeight28),
                                        dangerouslySetInnerHTML: {
                                            __html: t("h-4-sub5-desc")
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var advantage = (Advantage);

// EXTERNAL MODULE: ./components/HomePage/roadmap/index.module.less
var roadmap_index_module = __webpack_require__(2617);
var roadmap_index_module_default = /*#__PURE__*/__webpack_require__.n(roadmap_index_module);
;// CONCATENATED MODULE: ./components/HomePage/roadmap/index.tsx





const { staticFolder: roadmap_staticFolder  } = config_default()().publicRuntimeConfig;
const Roadmap = (props)=>{
    const t = (0,src/* useFm */.yv)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "section large top-120px   overflow-hidden wf-section ".concat((roadmap_index_module_default()).roadmap),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container-default w-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mg-bottom-64px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "inner-container _585px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inner-container _500px---tablet",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "inner-container _450px---mbl",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "inner-container _350px---mbp",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        "data-w-id": "7c97b945-6c81-2d8b-d6ab-9e41df00ded8",
                                        className: "display-2 mg-bottom-0",
                                        dangerouslySetInnerHTML: {
                                            __html: t("h-6-t")
                                        }
                                    })
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        "data-delay": "4000",
                        "data-animation": "slide",
                        className: "timeline-slider w-slider",
                        "data-autoplay": "false",
                        "data-easing": "ease",
                        // style="opacity:0"
                        "data-hide-arrows": "false",
                        "data-disable-swipe": "false",
                        "data-w-id": "b3651333-7eb4-ecae-ac2a-f77e4841c345",
                        "data-autoplay-limit": "0",
                        "data-nav-spacing": "3",
                        "data-duration": "500",
                        "data-infinite": "false",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "timeline-slider-mask w-slider-mask",
                            id: "w-slider-mask-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "testimonial-slide-card-wrapper left ".concat((roadmap_index_module_default()).wSlide),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "display-2 mg-bottom-24px",
                                            dangerouslySetInnerHTML: {
                                                __html: t("h-6-sub1-t")
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "mg-bottom-0 ".concat((roadmap_index_module_default()).pl20),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: t("h-6-sub1-li1")
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: t("h-6-sub1-li2")
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: t("h-6-sub1-li3")
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: t("h-6-sub1-li4")
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "testimonial-slide-card-wrapper center ".concat((roadmap_index_module_default()).wSlide),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "display-2 mg-bottom-24px",
                                            dangerouslySetInnerHTML: {
                                                __html: t("h-6-sub2-t")
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "mg-bottom-0 ".concat((roadmap_index_module_default()).pl20),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: t("h-6-sub2-li1")
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: t("h-6-sub2-li2")
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: t("h-6-sub2-li3")
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: t("h-6-sub2-li4")
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "testimonial-slide-card-wrapper right ".concat((roadmap_index_module_default()).wSlide),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "display-2 mg-bottom-24px",
                                            dangerouslySetInnerHTML: {
                                                __html: t("h-6-sub3-t")
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "mg-bottom-0 ".concat((roadmap_index_module_default()).pl20),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: t("h-6-sub3-li1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: t("h-6-sub3-li2")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var roadmap = (Roadmap);

// EXTERNAL MODULE: ./components/HomePage/security/index.module.less
var security_index_module = __webpack_require__(7066);
var security_index_module_default = /*#__PURE__*/__webpack_require__.n(security_index_module);
;// CONCATENATED MODULE: ./components/HomePage/security/index.tsx






const { staticFolder: security_staticFolder  } = config_default()().publicRuntimeConfig;
const Security = (props)=>{
    const t = (0,src/* useFm */.yv)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "cta-section cta-v1 wf-section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container-default z-index-1 w-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "inner-container _500px---mbl center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-layout-grid grid-2-columns cta-v1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: "w-node-cd49c5f0-c3b7-c48d-73ff-0422dd1cce67-1c2c5e56",
                            "data-w-id": "cd49c5f0-c3b7-c48d-73ff-0422dd1cce67",
                            className: "position-relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-w-id": "cd49c5f0-c3b7-c48d-73ff-0422dd1cce68",
                                    className: "image-wrapper cta-v1-top-image ".concat((security_index_module_default()).topImg),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(security_staticFolder, "/mufex/images/connect/1.png"),
                                        loading: "eager",
                                        alt: "MUFEX wallet",
                                        className: "image "
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-w-id": "cd49c5f0-c3b7-c48d-73ff-0422dd1cce6a",
                                    className: "image-wrapper cta-v1-bottom-image float ".concat((security_index_module_default()).bottomImg),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(security_staticFolder, "/mufex/images/connect/2.png"),
                                        loading: "eager",
                                        alt: "MUFEX bitcoin",
                                        className: "image "
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-w-id": "cd49c5f0-c3b7-c48d-73ff-0422dd1cce6c",
                                    className: "image-wrapper cta-v1-bottom-float float",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(security_staticFolder, "/mufex/images/connect/3.svg"),
                                        loading: "eager",
                                        alt: "MUFEX-eth",
                                        className: "image "
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-w-id": "cd49c5f0-c3b7-c48d-73ff-0422dd1cce6e",
                                    className: "image-wrapper cta-v1-top-float float",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(security_staticFolder, "/mufex/images/connect/4.svg"),
                                        loading: "eager",
                                        alt: "MUFEX-asset",
                                        className: "image "
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-w-id": "cd49c5f0-c3b7-c48d-73ff-0422dd1cce70",
                                    className: "image-wrapper cta-v1-middle-float main",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(security_staticFolder, "/mufex/images/connect/5.svg"),
                                        loading: "eager",
                                        alt: "protfolio",
                                        className: "image"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "w-node-cd49c5f0-c3b7-c48d-73ff-0422dd1cce72-1c2c5e56",
                            "data-w-id": "cd49c5f0-c3b7-c48d-73ff-0422dd1cce72",
                            className: "inner-container _545px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "w-node-cd49c5f0-c3b7-c48d-73ff-0422dd1cce73-1c2c5e56",
                                className: "cta-v1-content-left-wrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "display-2 color-neutral-800",
                                        children: t("h-5-t")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "inner-container _470px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "color-neutral-700 mg-bottom-40px",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    style: {
                                                        textAlign: "left"
                                                    },
                                                    children: [
                                                        " ",
                                                        t("h-5-li1"),
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    style: {
                                                        textAlign: "left"
                                                    },
                                                    children: [
                                                        " ",
                                                        t("h-5-li2"),
                                                        " "
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(downloadIcons/* default */.Z, {
                                        dark: true
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var security = (Security);

// EXTERNAL MODULE: ./components/HomePage/homeData/index.module.less
var homeData_index_module = __webpack_require__(176);
var homeData_index_module_default = /*#__PURE__*/__webpack_require__.n(homeData_index_module);
// EXTERNAL MODULE: ./api/index.ts + 1 modules
var api = __webpack_require__(5485);
;// CONCATENATED MODULE: ./components/HomePage/homeData/index.tsx







const { staticFolder: homeData_staticFolder  } = config_default()().publicRuntimeConfig;
const HomeData = (props)=>{
    const t = (0,src/* useFm */.yv)();
    const [data, setData] = (0,react.useState)({
        turnoverTotal: "",
        openInterest: "",
        tradeUserTotal: "",
        totalTradesNumber: ""
    });
    (0,react.useEffect)(()=>{
        async function getData() {
            const data = await (0,api/* getDashboardData */.ZS)();
            setData(data);
        }
        getData();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "section top-120px wf-section bg-secondary-3",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container-default w-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-w-id": "cd49c5f0-c3b7-c48d-73ff-0422dd1ccff1",
                className: "mg-bottom-48px w-dyn-list",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    role: "list",
                    className: "".concat((homeData_index_module_default()).borderClass, " grid-2-columns  w-dyn-items"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "w-node-cd49c5f0-c3b7-c48d-73ff-0422dd1ccff3-1c2c5e56",
                            role: "listitem",
                            className: "w-dyn-item",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "blog-card-image-wrapper inside-card",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(homeData_staticFolder, "/mufex/images/data/1.svg"),
                                    loading: "eager",
                                    alt: "MUFEX-data",
                                    className: "blog-card-image"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: "w-node-fb2f252d-2a0b-2aba-3cbe-192e8653d172-baf4a44e",
                            "data-w-id": "fb2f252d-2a0b-2aba-3cbe-192e8653d172",
                            // className="card _24px"
                            className: (homeData_index_module_default()).dataSectionRightClass,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    role: "listitem",
                                    className: "career-card-item career-card-item-self w-dyn-item",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        "data-w-id": "9120cd68-75aa-bb57-2eb8-0de2cb331a54",
                                        className: "career-card w-inline-block",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "mg-bottom-12px hover-h3",
                                                    children: "$ ".concat(formatThousandDigit(data.turnoverTotal))
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "details-wrapper wrap-mobile",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-200 color-neutral-400",
                                                        children: t("h-3-d1")
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    role: "listitem",
                                    className: "career-card-item career-card-item-self w-dyn-item",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        "data-w-id": "9120cd68-75aa-bb57-2eb8-0de2cb331a54",
                                        className: "career-card w-inline-block",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "mg-bottom-12px hover-h3",
                                                    children: "$ ".concat(formatThousandDigit(data.openInterest))
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "details-wrapper wrap-mobile",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-200 color-neutral-400",
                                                        children: t("h-3-d2")
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    role: "listitem",
                                    className: "career-card-item career-card-item-self w-dyn-item",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        "data-w-id": "9120cd68-75aa-bb57-2eb8-0de2cb331a54",
                                        className: "career-card w-inline-block",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "mg-bottom-12px hover-h3",
                                                    children: "".concat(formatThousandDigit(data === null || data === void 0 ? void 0 : data.totalTradesNumber))
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "details-wrapper wrap-mobile",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-200 color-neutral-400",
                                                        children: t("h-3-d4")
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "blog-card-image-wrapper inside-card"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var homeData = (HomeData);

// EXTERNAL MODULE: ./components/HomePage/perpetualFutures/index.module.less
var perpetualFutures_index_module = __webpack_require__(5363);
var perpetualFutures_index_module_default = /*#__PURE__*/__webpack_require__.n(perpetualFutures_index_module);
;// CONCATENATED MODULE: ./components/HomePage/perpetualFutures/index.tsx





const { staticFolder: perpetualFutures_staticFolder  } = config_default()().publicRuntimeConfig;
const PerpetualFutures = (props)=>{
    const t = (0,src/* useFm */.yv)();
    const [activeTab, setActiveTable] = (0,react.useState)(1);
    const handleChangeActive = (val)=>{
        if (val === activeTab) {
            return;
        }
        setActiveTable(val);
    };
    const TabSingle = (tabIndex)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "tab-link  w-inline-block w-tab-link ".concat((perpetualFutures_index_module_default()).tabItem, " ").concat(activeTab !== tabIndex && (perpetualFutures_index_module_default()).tabNoActive, "  ").concat(tabIndex == 2 && "middle"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tab-content-wrapper  ".concat(activeTab !== tabIndex && (perpetualFutures_index_module_default()).tabNoActive),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tab-image-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            loading: "eager",
                            src: "".concat(perpetualFutures_staticFolder, "/mufex/images/future/").concat(tabIndex, "-left-").concat(activeTab === tabIndex ? "selected" : "default", ".svg"),
                            alt: "Best Price Execution",
                            className: "feature-image"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mg-bottom-12px ".concat((perpetualFutures_index_module_default()).h3),
                                children: t("h-3-new-sub".concat(tabIndex, "-t"))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tab-body ".concat(activeTab !== tabIndex && (perpetualFutures_index_module_default()).bodyNoActive),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "color-neutral-400 mg-bottom-0 ".concat((perpetualFutures_index_module_default()).lineHeight28),
                                    children: t("h-3-new-sub".concat(tabIndex, "-desc"))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tab-icon-wrapper ".concat(activeTab !== tabIndex && (perpetualFutures_index_module_default()).iconNoActive),
                        onClick: ()=>handleChangeActive(tabIndex),
                        children: activeTab === tabIndex ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "20",
                            height: "3",
                            viewBox: "0 0 20 3",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M1 1.63965H19",
                                stroke: "#26F2D1",
                                strokeWidth: "2",
                                strokeLinecap: "square"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M12 2.63965V20.6396",
                                    stroke: "#26F2D1",
                                    strokeWidth: "2",
                                    strokeLinecap: "square"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M3 11.6396H21",
                                    stroke: "#26F2D1",
                                    strokeWidth: "2",
                                    strokeLinecap: "square"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "section large wf-section ".concat((perpetualFutures_index_module_default()).py160),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container-default w-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "inner-container _650px---tablet center _100---mbl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        "data-w-id": "cd49c5f0-c3b7-c48d-73ff-0422dd1cce86",
                        className: "inner-container _650px---table center ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inner-container _500px---mbl center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-center---tablet",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-w-id": "d8eeb1fe-fe65-4bc9-67d8-d1be98f314b6",
                                    className: "w-layout-grid grid-2-columns title-and-buttons",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "full-width-tablet",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "display-2 mg-bottom-40px ".concat((perpetualFutures_index_module_default()).mb48),
                                            dangerouslySetInnerHTML: {
                                                __html: t("h-3-new-t")
                                            }
                                        })
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        "data-w-id": "cd49c5f0-c3b7-c48d-73ff-0422dd1cce8c",
                        className: "card _24px mg-bottom-48px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-layout-grid grid-2-columns _1-col-tablet gap-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "w-node-cd49c5f0-c3b7-c48d-73ff-0422dd1cce93-1c2c5e56",
                                    "data-easing": "ease",
                                    "data-duration-in": "300",
                                    "data-duration-out": "100",
                                    className: "w-tabs",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tabs-menu-wrapper w-tab-menu",
                                        children: [
                                            TabSingle(1),
                                            TabSingle(2),
                                            TabSingle(3)
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "w-node-cd49c5f0-c3b7-c48d-73ff-0422dd1cce8e-1c2c5e56",
                                    className: "lightbox-wrapper ".concat((perpetualFutures_index_module_default()).rightImg),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(perpetualFutures_staticFolder, "/mufex/images/future/2-bg.png"),
                                        loading: "eager",
                                        alt: "",
                                        className: "video-bg-image"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var perpetualFutures = (PerpetualFutures);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@ant-design+react-slick@1.0.1_react@18.2.0/node_modules/@ant-design/react-slick/es/index.js + 8 modules
var es = __webpack_require__(4985);
// EXTERNAL MODULE: ./components/HomePage/announcement/index.module.less
var announcement_index_module = __webpack_require__(6183);
var announcement_index_module_default = /*#__PURE__*/__webpack_require__.n(announcement_index_module);
;// CONCATENATED MODULE: ./components/HomePage/announcement/index.tsx






const { staticFolder: announcement_staticFolder  } = config_default()().publicRuntimeConfig;
const Announcement = (props)=>{
    const t = (0,src/* useFm */.yv)();
    const noticeList = [
        // {
        //   content: 'notice1',
        //   link: 'https://www.mufex.finance/trade/usdt/BTCUSDT'
        // },
        // {
        //   content: 'notice2',
        //   link: 'https://docs.mufex.finance/mufex/support/mufex-affiliate-program'
        // }
        // {
        //   content: 'notice3',
        //   link: 'https://blog.mufex.finance/mufex-mainnet-launch-deposit-and-trade-to-enjoy-usdt-20-annualized-return-6e6922b4fdf3'
        // }
        {
            content: "notice4",
            link: "http://t.me/mufex_bot"
        }
    ];
    const settings = {
        dots: false,
        infinite: true,
        vertical: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (announcement_index_module_default()).announcement,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (announcement_index_module_default()).sliderWrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
                ...settings,
                children: noticeList.map((it, i)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (announcement_index_module_default()).itemCenter,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (announcement_index_module_default()).itemWidth,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: it.link,
                                className: (announcement_index_module_default()).itemWrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: (announcement_index_module_default()).trumpetIcon,
                                        src: "".concat(announcement_staticFolder, "/mufex/images/announcement/trumpet.svg"),
                                        alt: "trumpet"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (announcement_index_module_default()).itemText,
                                        children: [
                                            t(it.content),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        className: (announcement_index_module_default()).itemSvg,
                                        width: "16",
                                        height: "17",
                                        viewBox: "0 0 16 17",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M5.66666 13.1667L10.3333 8.49999L5.66666 3.83332",
                                            stroke: "black",
                                            strokeWidth: "1.33333",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                ]
                            })
                        })
                    }, i);
                })
            })
        })
    });
};
/* harmony default export */ var announcement = (Announcement);

// EXTERNAL MODULE: ./components/HomePage/hoverComp/index.module.less
var hoverComp_index_module = __webpack_require__(6165);
var hoverComp_index_module_default = /*#__PURE__*/__webpack_require__.n(hoverComp_index_module);
;// CONCATENATED MODULE: ./components/HomePage/hoverComp/index.tsx
//  @ts-nocheck





const { staticFolder: hoverComp_staticFolder  } = config_default()().publicRuntimeConfig;
const HoverComp = (props)=>{
    const t = (0,src/* useFm */.yv)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "center ".concat((hoverComp_index_module_default()).feedBack),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: "mailto:support@mufex.finance",
                    className: "btn-primary w-button",
                    rel: "noreferrer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M17.2221 15H9.44428L4.99984 18.3333V15H2.77762C2.48293 15 2.20031 14.8829 1.99194 14.6745C1.78357 14.4661 1.6665 14.1835 1.6665 13.8888V2.77774C1.6665 2.48305 1.78357 2.20044 1.99194 1.99206C2.20031 1.78369 2.48293 1.66663 2.77762 1.66663H17.2221C17.5167 1.66663 17.7994 1.78369 18.0077 1.99206C18.2161 2.20044 18.3332 2.48305 18.3332 2.77774V13.8888C18.3332 14.1835 18.2161 14.4661 18.0077 14.6745C17.7994 14.8829 17.5167 15 17.2221 15Z",
                                stroke: "black",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (hoverComp_index_module_default()).backText,
                            children: t("feedback")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "center ".concat((hoverComp_index_module_default()).homeSocials),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://twitter.com/mufex_Official/",
                        title: "Twitter",
                        rel: "noreferrer",
                        target: "_blank",
                        className: (hoverComp_index_module_default()).homeSocialItem,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: (hoverComp_index_module_default()).homeSocialIcon,
                                d: "M22.9022 5.00287C22.1905 5.30914 21.4423 5.52241 20.6762 5.6374C21.0344 5.576 21.5614 4.93123 21.7713 4.67026C22.09 4.2766 22.3329 3.82721 22.4877 3.34491C22.4877 3.30909 22.5235 3.25792 22.4877 3.23233C22.4696 3.22248 22.4494 3.21732 22.4288 3.21732C22.4082 3.21732 22.388 3.22248 22.37 3.23233C21.538 3.68286 20.6526 4.02672 19.7346 4.25577C19.7026 4.26554 19.6686 4.26642 19.6361 4.2583C19.6037 4.25019 19.574 4.23339 19.5504 4.20971C19.4789 4.12463 19.402 4.04429 19.3201 3.96921C18.9457 3.63375 18.5209 3.35919 18.0613 3.15558C17.4409 2.90104 16.7707 2.7908 16.1014 2.83319C15.452 2.87421 14.818 3.04839 14.2388 3.34491C13.6684 3.65753 13.1671 4.08223 12.765 4.5935C12.3421 5.11972 12.0367 5.73042 11.8695 6.38451C11.7316 7.00668 11.716 7.64972 11.8234 8.27786C11.8234 8.38532 11.8234 8.40067 11.7313 8.38532C8.08279 7.84802 5.08923 6.55338 2.64322 3.77475C2.53576 3.65194 2.47947 3.65194 2.39248 3.77475C1.3281 5.39178 1.84494 7.95036 3.1754 9.2143C3.35451 9.38317 3.53872 9.54692 3.73318 9.70043C3.12317 9.65713 2.52805 9.49182 1.9831 9.2143C1.88076 9.14778 1.82447 9.1836 1.81935 9.30641C1.80484 9.47668 1.80484 9.64786 1.81935 9.81813C1.92612 10.6341 2.2477 11.4071 2.75119 12.058C3.25468 12.709 3.92202 13.2145 4.68497 13.523C4.87096 13.6026 5.06476 13.6626 5.26322 13.7021C4.6985 13.8132 4.11931 13.8305 3.54896 13.7532C3.42615 13.7276 3.38009 13.7942 3.42615 13.9119C4.17837 15.9587 5.81075 16.583 7.00818 16.931C7.17193 16.9566 7.33568 16.9566 7.51989 16.9975C7.51989 16.9975 7.51989 16.9975 7.48919 17.0282C7.13611 17.673 5.70841 18.1079 5.05341 18.3331C3.85787 18.7625 2.5832 18.9267 1.31787 18.8141C1.1183 18.7834 1.07224 18.7885 1.02107 18.8141C0.969898 18.8397 1.02107 18.896 1.07736 18.9472C1.33322 19.116 1.58908 19.2644 1.85517 19.4077C2.64733 19.8398 3.48481 20.183 4.35236 20.4311C8.84525 21.6695 13.901 20.7586 17.2732 17.4069C19.924 14.7767 20.8553 11.1486 20.8553 7.5154C20.8553 7.37724 21.0241 7.29536 21.1214 7.22372C21.792 6.70121 22.3832 6.08413 22.8766 5.39178C22.962 5.28857 23.0058 5.15717 22.9994 5.02334V5.02334C22.9994 4.94658 22.9994 4.96194 22.9022 5.00287Z",
                                fill: "white"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://t.me/mufex",
                        title: "Telegram",
                        rel: "noreferrer",
                        target: "_blank",
                        className: (hoverComp_index_module_default()).homeSocialItem,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: (hoverComp_index_module_default()).homeSocialIcon,
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M19.2533 21.5492L22.9869 3.59063C23.083 3.12751 22.6279 2.74115 22.1869 2.9117L1.38254 10.9375C0.869073 11.1353 0.873473 11.8622 1.38841 12.0551L6.45767 13.947L8.41978 20.2572C8.54536 20.6611 9.03955 20.8106 9.36745 20.5424L12.1932 18.239C12.4894 17.9975 12.9113 17.9855 13.2207 18.2102L18.3174 21.9104C18.6682 22.1654 19.1654 21.9732 19.2533 21.5492ZM8.10363 12.94L18.0108 6.83821C18.1888 6.72891 18.3721 6.96965 18.219 7.11143L10.0428 14.7116C9.7553 14.9791 9.57001 15.3373 9.51742 15.7259L9.23904 17.7899C9.20195 18.0654 8.81503 18.0926 8.73884 17.826L7.66769 14.0622C7.54519 13.6329 7.72391 13.1743 8.10363 12.94Z",
                                fill: "white"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://discord.com/invite/m6DD42s46n",
                        title: "Discord",
                        rel: "noreferrer",
                        target: "_blank",
                        className: (hoverComp_index_module_default()).homeSocialItem,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: (hoverComp_index_module_default()).homeSocialIcon,
                                d: "M20.0001 4.71912C22.5977 8.53826 23.8805 12.8461 23.401 17.8055C23.399 17.8265 23.388 17.8458 23.3708 17.8584C21.4037 19.3028 19.4979 20.1794 17.6188 20.7607C17.6042 20.7651 17.5885 20.7649 17.574 20.76C17.5595 20.7551 17.5469 20.7458 17.538 20.7334C17.1039 20.1294 16.7094 19.4925 16.3638 18.8238C16.344 18.7844 16.3621 18.737 16.403 18.7215C17.0294 18.4854 17.6251 18.2025 18.1981 17.8676C18.2432 17.8412 18.2461 17.7765 18.2044 17.7454C18.0828 17.6551 17.9623 17.5603 17.8471 17.4654C17.8255 17.4479 17.7965 17.4444 17.772 17.4562C14.0521 19.174 9.97705 19.174 6.2131 17.4562C6.18867 17.4453 6.15963 17.449 6.13864 17.4663C6.02364 17.5611 5.90289 17.6551 5.78243 17.7454C5.74074 17.7765 5.74419 17.8412 5.78962 17.8676C6.3626 18.1962 6.9583 18.4854 7.5839 18.7226C7.62444 18.7382 7.6437 18.7844 7.62358 18.8238C7.28548 19.4934 6.89103 20.1302 6.44885 20.7343C6.42959 20.7587 6.39797 20.7699 6.36807 20.7607C4.49788 20.1794 2.59205 19.3028 0.624977 17.8584C0.608589 17.8458 0.596802 17.8256 0.595077 17.8046C0.194303 13.5149 1.01109 9.17133 3.99275 4.71826C3.99993 4.70647 4.01086 4.69727 4.02351 4.69181C5.49062 4.01849 7.06238 3.52312 8.70515 3.24023C8.73505 3.23563 8.76495 3.24943 8.78048 3.27588C8.98345 3.63525 9.21546 4.09611 9.37244 4.47273C11.104 4.20823 12.8627 4.20823 14.6305 4.47273C14.7875 4.10416 15.0115 3.63525 15.2136 3.27588C15.2208 3.26275 15.2319 3.25224 15.2454 3.24584C15.259 3.23944 15.2742 3.23747 15.2889 3.24023C16.9325 3.52399 18.5043 4.01935 19.9702 4.69181C19.9832 4.69727 19.9938 4.70647 20.0001 4.71912V4.71912ZM10.2528 12.8755C10.2709 11.6073 9.34627 10.5579 8.18564 10.5579C7.03449 10.5579 6.11881 11.5981 6.11881 12.8755C6.11881 14.1525 7.0526 15.1927 8.18564 15.1927C9.33707 15.1927 10.2528 14.1525 10.2528 12.8755V12.8755ZM17.8951 12.8755C17.9132 11.6073 16.9886 10.5579 15.8282 10.5579C14.6768 10.5579 13.7611 11.5981 13.7611 12.8755C13.7611 14.1525 14.6949 15.1927 15.8282 15.1927C16.9886 15.1927 17.8951 14.1525 17.8951 12.8755V12.8755Z",
                                fill: "white"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.youtube.com/channel/UC0VQ8_HuC8yeiJvEbrfmRqw",
                        title: "YouTube",
                        rel: "noreferrer",
                        target: "_blank",
                        className: (hoverComp_index_module_default()).homeSocialItem,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 18",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: (hoverComp_index_module_default()).homeSocialIcon,
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M21.3904 0.550588C22.4184 0.847059 23.2289 1.71529 23.5057 2.81647C24.0197 4.82824 23.9999 9.02118 23.9999 9.02118C23.9999 9.02118 23.9999 13.1929 23.5057 15.2047C23.2289 16.3059 22.4184 17.1741 21.3904 17.4706C19.5123 18 11.9999 18 11.9999 18C11.9999 18 4.50739 18 2.60954 17.4494C1.58154 17.1529 0.771002 16.2847 0.494232 15.1835C0 13.1929 0 9 0 9C0 9 0 4.82824 0.494232 2.81647C0.771002 1.71529 1.60131 0.825882 2.60954 0.529412C4.48763 0 11.9999 0 11.9999 0C11.9999 0 19.5123 0 21.3904 0.550588ZM15.8549 8.85281L9.60779 12.7069V4.9987L15.8549 8.85281Z",
                                fill: "white"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://blog.mufex.finance/",
                        title: "Medium",
                        rel: "noreferrer",
                        target: "_blank",
                        className: (hoverComp_index_module_default()).homeSocialItem,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                className: (hoverComp_index_module_default()).homeSocialIcon,
                                d: "M13.5374 11.9998C13.5374 15.7637 10.507 18.815 6.76859 18.815C3.03022 18.815 0 15.7646 0 11.9998C0 8.23503 3.03045 5.18481 6.76859 5.18481C10.5067 5.18481 13.5374 8.23595 13.5374 11.9998ZM20.9629 11.9998C20.9629 15.543 19.4475 18.4151 17.5785 18.4151C15.7094 18.4151 14.1941 15.5421 14.1941 11.9998C14.1941 8.45751 15.7094 5.58451 17.5785 5.58451C19.4475 5.58451 20.9629 8.45751 20.9629 11.9998ZM24 11.9998C24 15.1744 23.467 17.7477 22.8097 17.7477C22.1523 17.7477 21.6193 15.1734 21.6193 11.9998C21.6193 8.82618 22.1523 6.25196 22.8099 6.25196C23.4675 6.25196 24 8.82549 24 11.9998Z",
                                fill: "white"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var hoverComp = (HoverComp);

;// CONCATENATED MODULE: ./components/HomePage/index.tsx












/***/ }),

/***/ 1172:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btnLink":"index_btnLink__1SZAS","lineHeight28":"index_lineHeight28___ZPtF"};

/***/ }),

/***/ 6183:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"announcement":"index_announcement__jLWFV","sliderWrapper":"index_sliderWrapper__yyZ8P","itemCenter":"index_itemCenter__UKCqN","itemWidth":"index_itemWidth___Hi2b","itemWrapper":"index_itemWrapper__Jsw_b","trumpetIcon":"index_trumpetIcon__LltyM","itemText":"index_itemText__fmauJ","itemSvg":"index_itemSvg__OTJbF"};

/***/ }),

/***/ 5369:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"socialwrapper":"index_socialwrapper__U7NE2","socialBase":"index_socialBase__FTBF6","gridWrapper":"index_gridWrapper__wV3CW","content":"index_content__HMIsa","btn":"index_btn__ns1LF"};

/***/ }),

/***/ 371:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"homeBanner":"index_homeBanner__ihf3p","btn":"index_btn__DNhRt"};

/***/ }),

/***/ 176:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dataSectionRightClass":"index_dataSectionRightClass__b3Gwh","borderClass":"index_borderClass__Nlt_F","dataTipClass":"index_dataTipClass__7LnnX"};

/***/ }),

/***/ 6165:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"feedBack":"index_feedBack__HKaZV","backText":"index_backText__sdJmX","homeSocialIcon":"index_homeSocialIcon__WnNDN","homeSocials":"index_homeSocials__I9dq5","homeSocialItem":"index_homeSocialItem__whxgR"};

/***/ }),

/***/ 9182:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"partnerClass":"index_partnerClass__jQvuh","imgWrapperClass":"index_imgWrapperClass__oX0O9","partnerAnimation":"index_partnerAnimation__MVbNj"};

/***/ }),

/***/ 5363:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tabItem":"index_tabItem__c9BuY","bodyNoActive":"index_bodyNoActive__QTApI","iconNoActive":"index_iconNoActive__2k6FK","lineHeight28":"index_lineHeight28__485Az","mb48":"index_mb48__CcD0f","py160":"index_py160__QA1gL","h3":"index_h3__QTNSA","tabNoActive":"index_tabNoActive__bgEkH","rightImg":"index_rightImg__u2oY_"};

/***/ }),

/***/ 2617:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"roadmap":"index_roadmap__RnlED","pl20":"index_pl20__eUazO","wSlide":"index_wSlide__V1XD8"};

/***/ }),

/***/ 7066:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"topImg":"index_topImg__q6_df","bottomImg":"index_bottomImg__S1_I_"};

/***/ })

}]);